var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "delete-icon--grey.11b3216e") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-Desktop",
    transform: "translate(-433.000000, -361.000000)",
    fill: "#B9B9B9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(95.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete-icon--grey.11b3216e",
    transform: "translate(338.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2173913,2.83425415 L12.3130435,2.83425415 L12.3130435,1.83701658 C12.3130435,0.822460337 11.4954765,0 10.4869565,0 L7.51304346,0 C6.50452349,0 5.68695651,0.822460337 5.68695651,1.83701658 L5.68695651,2.83425415 L0.782608694,2.83425415 C0.350385847,2.83425415 0,3.18673715 0,3.62154696 C0,4.05635678 0.350385847,4.40883978 0.782608694,4.40883978 L2.37391304,4.40883978 L2.37391304,16.1132597 C2.37391304,17.7075624 3.65866115,19 5.24347826,19 L12.7565217,19 C14.3413388,19 15.626087,17.7075624 15.626087,16.1132597 L15.626087,4.40883978 L17.2173913,4.40883978 C17.6496142,4.40883978 18,4.05635678 18,3.62154696 C18,3.18673715 17.6496142,2.83425415 17.2173913,2.83425415 Z M7.25217394,1.83701658 C7.25217394,1.69207997 7.36896922,1.57458564 7.51304346,1.57458564 L10.4869565,1.57458564 C10.6310308,1.57458564 10.747826,1.69207997 10.747826,1.83701658 L10.747826,2.83425415 L7.25217394,2.83425415 L7.25217394,1.83701658 Z M14.0347826,16.1395028 C14.0347826,16.8641858 13.4508062,17.4516574 12.7304348,17.4516574 L5.24347826,17.4516574 C4.52310684,17.4516574 3.93913043,16.8641858 3.93913043,16.1395028 L3.93913043,4.40883978 L14.0608695,4.40883978 L14.0347826,16.1395028 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,15 C11.5522848,15 12,14.6632782 12,14.2479108 L12,6.75208913 C12,6.33672177 11.5522848,6 11,6 C10.4477152,6 10,6.33672177 10,6.75208913 L10,14.2479108 C10,14.6632782 10.4477152,15 11,15 L11,15 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,15 C7.55228475,15 8,14.6632782 8,14.2479108 L8,6.75208913 C8,6.33672177 7.55228475,6 7,6 C6.44771526,6 6,6.33672177 6,6.75208913 L6,14.2479108 C6,14.6632782 6.44771526,15 7,15 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGrey);
export default __webpack_public_path__ + "static/media/delete-icon--grey.a4192542851f1ff14022a60b7fa9ed37.svg";
export { ForwardRef as ReactComponent };